import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { ampli } from '../../../../ampli';

export const AfterJoinPage = () => {
  const navigate = useNavigate();

  useEffect(() => {
    ampli.유저회원가입완료();
    sessionStorage.setItem('join-complete', 'true');
    navigate('/after-login', { replace: true });
  }, [navigate]);

  return <></>;
};
